/**
 * Филиалы, где можно оплатить запись наличными. Контент для UI; сам лимит мест
 * и цена живут на бэкенде (courses.constants.ts + «⚙️ Типы услуг»).
 */
export const CASH_BRANCHES: { name: string; address: string }[] = [
  { name: "Грушевка", address: "просп. Жукова, 29" },
  { name: "Немига", address: "ул. Зыбицкая, 2, 3 этаж" },
  { name: "Восток", address: "ул. Кирилла Туровского, 2" },
  { name: "Пушкинская", address: "просп. Притыцкого, 2/3, 2 этаж" },
];
